import React from 'react';
import { motion } from 'framer-motion';
import { ScanLineIcon, BanknoteIcon } from 'lucide-react';
const steps = [{
  icon: ScanLineIcon,
  title: 'Connect & analyze',
  text: 'Connect your inventory feed or upload a file. Carli evaluates pricing, demand, condition, logistics, and sell-through potential.'
}, {
  solidStar: true,
  title: 'Optimize the recovery path',
  text: 'Our AI recommends the best price, buyer, and controlled channel based on your inventory and brand guardrails.'
}, {
  icon: BanknoteIcon,
  title: 'Recover more value',
  text: 'ManyCo activates the strategy and manages sell-through—helping you recover more while protecting your brand and existing channels.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="mx-auto max-w-6xl px-5 py-20 sm:px-8 lg:py-28" data-id="element-1764" data-mp="14j5t84piaoi6">
      <div className="max-w-2xl" data-id="element-1765" data-mp="14hb7io6eusd1">
        <span className="text-xs font-semibold uppercase tracking-wider text-forest" data-id="element-1766" data-mp="19adzwszgbvrn">
          How it works
        </span>
        <h2 className="mt-2 font-display text-3xl font-medium tracking-tight text-ink sm:text-4xl" data-id="element-1767" data-mp="2rmfu8pxrgop7">
          From stranded inventory to higher recovery in three steps.
        </h2>
      </div>

      <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-1768" data-mp="31ciu9a3av2x1">
        {steps.map((s, i) => <motion.div key={s.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="rounded-2xl border border-ink/10 bg-paper p-7" data-id="element-1769" data-mp="2wkhfnhint03u" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-1770" data-mp="3k9k1z2o8nh4o">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-forest/10 text-forest" data-id="element-1771" data-mp="3fca5j32fm57c">
                {s.solidStar ? <span aria-hidden="true" className="h-5 w-5 bg-forest" style={{
              WebkitMaskImage: 'url(https://cdn.magicpatterns.com/uploads/uszYpUgDHbmVmVvdioqNYy/Icon_OffWhite.svg)',
              maskImage: 'url(https://cdn.magicpatterns.com/uploads/uszYpUgDHbmVmVvdioqNYy/Icon_OffWhite.svg)',
              WebkitMaskRepeat: 'no-repeat',
              maskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
              maskPosition: 'center',
              WebkitMaskSize: 'contain',
              maskSize: 'contain'
            }} data-id="element-1772" data-mp="1py5dsqavlpr1" /> : <s.icon className="h-5 w-5" data-id="element-1773" data-mp="hii8apkcndc2" />}
              </span>
              <span className="font-display text-2xl font-medium text-ink/15" data-id="element-1774" data-mp="lkvbp7bmiz5o">0{i + 1}</span>
            </div>
            <h3 className="mt-5 text-lg font-semibold text-ink" data-id="element-1775" data-mp="qk7yjs2hw689">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink/65" data-id="element-1776" data-mp="vi9sx95dfrz1">{s.text}</p>
          </motion.div>)}
      </div>
    </section>;
}